import { Box, Checkbox, FormControlLabel, FormControlLabelProps } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormError from './FormError';

type FormCheckboxProps = Omit<FormControlLabelProps, 'control'> & {
    name: string;
    enableSpacing?: boolean;
};

export default function FormCheckbox(props: FormCheckboxProps) {
    const {
        name,
        label,
        enableSpacing,
        disabled,
        checked: checkedOverride,
        ...rest
    } = props;

    const {
        register,
        watch,
        formState: { errors },
    } = useFormContext();

    const checked = watch(name) ?? checkedOverride ?? false;

    const errorMessage = typeof errors[name]?.message === 'string' ? errors[name]?.message as string : undefined;

    return (
        <Box marginBottom={(errorMessage && !disabled) || !enableSpacing ? 0 : 2.5}>
            <FormControlLabel
                control={(
                    <Checkbox
                        {...(!disabled ? register(name) : {})}
                        checked={checked}
                        disabled={disabled}
                    />
                )}
                label={label}
                {...rest}
            />
            <FormError show={Boolean(errorMessage) && !disabled}>
                {errorMessage}
            </FormError>
        </Box>
    );
}
